import type { ReactNode } from "react";

/**
 * Empty state (screens.md → "States not drawn"). Keep the screen's chrome;
 * center a faint message + the screen's primary action. Never an illustration.
 */
export function EmptyState({ message, action }: { message: string; action?: ReactNode }) {
  return (
    <div className="flex flex-col items-center justify-center gap-4 rounded-ge-card border border-ge-border-subtle bg-ge-card/40 px-6 py-16 text-center">
      <p className="max-w-md text-[13px] text-ge-secondary">{message}</p>
      {action}
    </div>
  );
}
